import './administrator-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { UserTrackingFunction } from '@tracking/models/tracking-function';
import { RESET_TRACKING_FILTER } from '@tracking/table/tracking-table.component.ajs';
import { IUserTrackingService } from '@tracking/tracking.service';
import { IComponentController, IComponentOptions } from 'angular';

import { MessagingService } from '@contact/upgrade';

import templateUrl from './administrator-filter.component.ajs.html';

const MODULE_NAME = 'contactAdministratorFilter';

class AdministratorFilterControler implements IComponentController {
  public name = MODULE_NAME;

  public admins: Array<any> = [];
  private selectedAdmin: any = null;
  public users: any[] = [];
  private selectedUser: any = null;
  public skills: Array<any> = [];
  private selectedSkill: any = null;
  private onlyAlert: boolean;

  constructor(private readonly tracking: IUserTrackingService, private readonly messaging: MessagingService) {
    tracking.setFunction(UserTrackingFunction.ADMINISTRATOR);
    tracking.getSkillList().then(skills => {
      this.skills = skills;
    });
    tracking.getAdministratorUserList().then(administrators => {
      this.admins = administrators.map(admin => {
        admin.name = admin.firstName + ' ' + admin.lastName;
        return admin;
      });
    });
    tracking.getUserList().then(users => {
      this.users = users.map(user => {
        user.name = user.firstName + ' ' + user.lastName;
        return user;
      });
    });

    // RESET_TRACKING_FILTER
    this.messaging
      .forLocal()
      .listen$(RESET_TRACKING_FILTER)
      .pipe(ng1Destroy(this))
      .subscribe(() => this.resetFilters());
  }

  $onInit() {}

  private updateFilters() {
    let idFilters: any[] = [];
    if (this.selectedUser != null && this.selectedUser.hasOwnProperty('uuid')) {
      idFilters.push(this.selectedUser.uuid);
    }
    if (this.selectedSkill != null && this.selectedSkill.hasOwnProperty('uuid')) {
      idFilters.push(this.selectedSkill.uuid);
    }
    if (idFilters.length > 0) {
      this.tracking.updateFilters('targetId', idFilters);
    } else {
      this.tracking.updateFilters('targetId', null);
    }
    if (this.onlyAlert) {
      idFilters.push('ALERT_CATEGORY');
      idFilters.push('ALERT_TEMPLATE');
      this.tracking.updateFilters('targetType', idFilters);
    } else {
      this.tracking.updateFilters('targetType', null);
    }
  }

  private resetFilters(): void {
    this.selectedAdmin = undefined;
    this.selectedUser = undefined;
    this.selectedSkill = undefined;
    this.onlyAlert = false;
  }

  public adminChanged(): void {
    if (this.selectedAdmin) {
      this.tracking.updateFilters('userId', this.selectedAdmin.uuid);
    } else {
      this.tracking.updateFilters('userId', null);
    }
  }

  public userChanged(): void {
    this.updateFilters();
  }

  public skillChanged(): void {
    this.updateFilters();
  }

  public resetSkill(): void {
    this.selectedSkill = null;
    this.updateFilters();
  }

  public alertChanged(): void {
    this.updateFilters();
  }
}

export class AdministratorFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = ['tracking', 'messaging', AdministratorFilterControler];
}

export default MODULE_NAME;
